module.exports = __webpack_public_path__ + "static/anti-racist-teaching-8d56e55c25c505a33d1ae1b202dc4460.jpg";